module.exports = __webpack_public_path__ + "static/media/ArrowRight.b65e7703.svg";